import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const useQueryParams = (queryParamCastFunctions: { [key: string]: (value: string) => any } = {}) => {
  const { search } = useLocation()

  const queryParams = useMemo(() => Object.fromEntries(new URLSearchParams(search)), [search])

  const castedQueryParams = useMemo(
    () =>
      Object.assign(
        {},
        ...Object.keys(queryParams).map((queryParam) => ({
          [queryParam]:
            queryParam in queryParamCastFunctions
              ? queryParamCastFunctions[queryParam](queryParams[queryParam])
              : queryParams[queryParam],
        })),
      ),
    [queryParams, queryParamCastFunctions],
  )

  return castedQueryParams
}
